import { render, staticRenderFns } from "./reactivate-parcel-modal.vue?vue&type=template&id=52b83255"
import script from "./reactivate-parcel-modal.vue?vue&type=script&lang=ts"
export * from "./reactivate-parcel-modal.vue?vue&type=script&lang=ts"
import style0 from "./reactivate-parcel-modal.vue?vue&type=style&index=0&id=52b83255&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports